import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { averageTicketMessages } from 'pages/admin/demand/averageTicket/variables/averageTicketMessages';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const calculateAverageTicket = async (
	intervaloTempo: number | string
) => {
	let url = `/ticketMedio/calcularTicketMedio?`;

	if (intervaloTempo) {
		url += `&intervaloTempo=${+intervaloTempo}&historicoCompleto=false`;
	} else {
		url += `&historicoCompleto=true`;
	}

	const response = await api.get(url);
	return response.data;
};
export const useCalculateAverageTicket = (intervaloTempo: number | string) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation({
		mutationFn: () => calculateAverageTicket(intervaloTempo),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['ticketMedio-list'] });
			toast({
				title: averageTicketMessages.MSG_AVERAGE_TICKET_RECALCULATED
					.title,
				description:
					averageTicketMessages.MSG_AVERAGE_TICKET_RECALCULATED.text,
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				averageTicketMessages.MSG_ERROR_AVERAGE_TICKET_RECALCULATED
					.title
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
